import React from 'react';
import { useTranslation } from 'react-i18next';
import * as CookieConsent from 'vanilla-cookieconsent';
import CookieIcon from "@mui/icons-material/Cookie";

const CookieConsentComponent = () => {
    const { t } = useTranslation();
    const ariaLabel = t('cookieConsent.ariaLabel', 'Manage cookie preferences');

    return (
        <button
            onClick={CookieConsent.showPreferences}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#d6cfca', padding: 0 }}
            aria-label={ariaLabel}
        ><CookieIcon style={{fontSize: '2rem'}}/>
        </button>
    );
};

export default CookieConsentComponent;
